import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppService } from '../shared/service/AppService.class';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
// import { environment } from '../../assets/deatails.json';


@Injectable()
export class AuthenticationService extends AppService<any>{
  constructor(protected http: HttpClient, protected router: Router) {
    super(http);
    this.appmod = "login";
  }

  userlogin(data:any): Observable<any>{ ///
    this.appmod = 'login';
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }

  getDetails(data?:any): Observable<any>{ 
    // return this.http.get('../../assets/details.json')
    let temp = this.appmod;
    this.appmod = "custom/details";
    let result = super.getService(data);
    this.appmod = temp;
    return result;
  }
  

  forgotPassword(data): Observable<any>{ ///
    this.appmod = "custom/forgetpassword";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }


  resetpassword(data:any): Observable<any>{  ////
    this.appmod = "custom/resetpassword";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }

  registeruser(data:any): Observable<any>{  ////
    this.appmod = "custom/register";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }

  // checkuseremail(data:any): Observable<any>{  ////
  //   this.appmod = "custom/checkuseremail";
  //   let result = super.getService(data);
  //   this.appmod = "login";
  //   return result;
  // }

  googlelogin(): Observable<any>{  ////
    this.appmod = "custom/googlelogin";
    let result = super.getService();
    this.appmod = "login";
    return result;
  }

  getuseraccess(data:any): Observable<any>{  ////
    this.appmod = "custom/getuseraccess";
    let result = super.getService(data);
    this.appmod = "login";
    return result;
  }



  logout() {
    let token = sessionStorage.getItem('token');
    this.getService(token).subscribe(res => {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'])
    }, err => {
      console.log(err)
    });
  }
  

  // getBalance() {
  //   this.appmod = "userbalance";
  //   let resBal = super.getService();
  //   this.appmod = "login";
  //   return resBal;
  // }

  // getservertime(): any {
  //   this.appmod = "getservertime";
  //   let time = super.getService();
  //   this.appmod = "login";
  //   return time;
  // }

  // public SaveSignUpFormData(data): Observable<any> {
  //   this.appmod = "signuplogin";
  //   let result = super.saveService(data);
  //   this.appmod = "login";
  //   return result;
  // }

  // getMailVerification(params){
  //   this.appmod = "getmailverification";
  //   let result = super.getService(params);
  //   this.appmod = "login";
  //   return result;
  // }

  // sendMailVerification(params){
  //   this.appmod = "sendmailverification";
  //   let result = super.getService(params);
  //   this.appmod = "login";
  //   return result;
  // }

  // updateUserVarification(id){
  //   this.appmod = "updatemailverification";
  //   let result = super.saveService(id);
  //   this.appmod = "login";
  //   return result;
  // }

  // ChangeUserPassword(data){
  //   this.appmod = "custom/changeuserpassword";
  //   let result = super.saveService(data,"main");
  //   this.appmod = "login";
  //   return result;
  // }

  // otp_Verification(data){
  //   this.appmod = "custom/otp_Verification";
  //   let result = super.saveService(data);
  //   this.appmod = "login";
  //   return result;
  // }

  // call_vefied(data){
  //   this.appmod = "custom/call_vefied";
  //   let result = super.saveService(data);
  //   this.appmod = "login";
  //   return result;
  // }



  // resetpassword(data){
  //   this.appmod = "custom/forgetpasswordchange";
  //   let result = super.saveService(data);
  //   this.appmod = "login";
  //   return result;
  // }

  remove_Sample(){
    this.appmod = "custom/remove_Sample";
    let result = super.getService();
    this.appmod = "login";
    return result;
  }

  // public getSampleData(): Observable<any> {
  //   this.appmod = "saveagentgroup";
  //   let result = super.getService();
  //   this.appmod = "agents";
  //   return result;
  // }

  saveNavigation(data){
    this.appmod = "navigation";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }

  custumerStatus(data){
    this.appmod = "customerstatus";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }
  // getLoginCustomer(data:any){
  //   this.appmod = "custom/getLoginCustomer";
  //   let result = super.getService(data);
  //   this.appmod = "login";
  //   return result;
  // }
  ssologin(data:any): Observable<any>{  
    this.appmod = "custom/ssologin";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }
  
  customerlogout(): Observable<any>{  
    this.appmod = "customerlogout";
    let result = super.getService();
    this.appmod = "login";
    return result;
    // this.redirectToPanel();
  }


  redirectToPanel() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = environment.cental_url+'/login';
  }
  ai_setup(data:any): Observable<any>{
    this.appmod = "custom/ai_data";
    let result = super.getService(data);
    this.appmod = "login";
    return result;
  }
  ai_setup_save(data:any): Observable<any>{
    this.appmod = "custom/ai_setup_save";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }
  get_business(): Observable<any>{
    this.appmod = "custom/get_business";
    let result = super.getService();
    this.appmod = "login";
    return result;
  }
  get_business_type(data:any): Observable<any>{
    this.appmod = "custom/get_business_type";
    let result = super.getService(data);
    this.appmod = "login";
    return result;
  }

  registerGoogleUser(data:any): Observable<any>{
    this.appmod = "custom/registerGoogleUser";
    let result = super.saveService(data);
    this.appmod = "login";
    return result;
  }
  getTokenLogin(data:any): Observable<any>{
    this.appmod = "custom/getTokenLogin";
    let result = super.getService(data);
    this.appmod = "login";
    return result;
  }

  verifyEmail(data:any): Observable<any>{
    this.appmod = "custom/verifyEmail";
    let result = super.getService(data);
    this.appmod = "login";
    return result;
  }

  resendVerificationEmail(data:any): Observable<any>{
    this.appmod = "custom/resendVerificationEmail";
    let result = super.getService(data);
    this.appmod = "login";
    return result;
  }

}